var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('resource',{attrs:{"resource":"news","resourceName":"Artikel","createMode":true,"attributes":[
      {
        name: 'title',
        label: 'Titel'
      },
      {
        name: 'article',
        label: 'Artikel',
        type: 'WYSIWYGSelector',
        editorToolbar: [
          { header: [false, 1, 2, 3, 4, 5, 6] },
          'bold',
          'italic',
          'underline',
          'strike',
          'code-block',
          { list: 'ordered' },
          { list: 'bullet' },
          { color: [] },
          { background: [] },
          'clean'
        ]
      },
      {
        name: 'release_time',
        label: 'Veröffentlichungsdatum',
        type: 'DateTimeSelector'
      },
      {
        name: 'read_type',
        label: 'Newscounter',
        type: 'SelectSelector'
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Artikel erstellen")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }